import { Label, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutQuoteCustomerLookup } from "./autogen/AutogenLayoutQuoteCustomerLookup";

export class QuoteCustomerLookup extends AutogenLayoutQuoteCustomerLookup {

    tableCustomerOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const labelTypeOf = tableRow.findComponentById("labelTypeOf") as Label;
        if (labelTypeOf) {
            labelTypeOf.visible = modelRow.getString("type_of") == "P";
            if (labelTypeOf.visible) {
                labelTypeOf.text = "Prospect";
            }
        }
    }

}